export enum QueryNames {
  CheckpointData = 'CheckpointData',
  ChecklistData = 'ChecklistData'
}
